const VIDEO_PLAYER_LABEL = "Open Video Player";

export { VIDEO_PLAYER_LABEL };
